/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Type_MeetingInputs */

const vi_work_activity_type_meeting = /** @type {(inputs: Work_Activity_Type_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch họp`)
};

/**

* @param {Work_Activity_Type_MeetingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_type_meeting = /** @type {((inputs?: Work_Activity_Type_MeetingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Type_MeetingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_type_meeting(inputs)
});